export default __webpack_public_path__ + "static/media/Dodge and Strike.116f7ec3.png";